export default "__VITE_ASSET__BuodZJqe__"